import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';



class CategoryLogos extends Component {

    render() {
        const categories = this.props.categories.items;
        console.log(categories)
        return (
            <div className="CategoryLogos">
                <div className="top-CategoryLogos">
                    {
                        categories !== null && categories.map((category, i) => {

                            return (
                                <div className="category-icon" key={i}>
                                    {category.level === 1 &&
                                        <Link to={'/merchants/' + category.id} >
                                            <i className={category.icon}></i>
                                            <span >{category.name}</span>
                                        </Link>
                                    }


                                </div>
                            )

                        })
                    }

                    {/* 
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-briefcase-medical"></i>
                            <span >پزشکی و سلامت </span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-tshirt"></i>
                            <span >پوشاک</span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-home"></i>
                            <span >خانه، ساختمان و تاسیسات </span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-people-carry"></i>
                            <span >خدمات عمومی و دولتی </span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-utensils"></i>
                            <span >رستوران و غذا</span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-tractor"></i>
                            <span >صنعت، تولید، کشاورزی </span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-prescription-bottle-alt"></i>
                            <span >آرایشی و بهداشتی </span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-chalkboard-teacher"></i>
                            <span >آموزش و پژوهش</span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-bolt"></i>
                            <span >الکترونیک و دیجیتال</span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-bus-alt"></i>
                            <span >حمل و نقل</span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-map-marker-alt"></i>
                            <span >سفر و گردشگری</span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="far fa-map"></i>
                            <span >چاپ و تبلیغات</span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-futbol"></i>
                            <span >ورزش،سرگرمی،هنر</span>
                        </Link>
                    </div>
                    <div className="category-icon">
                        <Link to="/">
                            <i className="fas fa-car"></i>
                            <span >خودرو و وسیله نقلیه</span>
                        </Link>
                    </div> */}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        categories: state.categories,
    }
};
// const mapDispatchToProps = dispatch => {
//     return {
//         setCategories: categories => {
//             dispatch(setCategories(categories))
//         }
//     }
// };

export default connect(mapStateToProps, null)(CategoryLogos);



// WEBPACK FOOTER //
// ./src/containers/home/categorylogos.jsx